module.exports = __webpack_public_path__ + "static/media/fp-icon.dbd1a11d.svg";